<div class="message-wrapper" [class.incoming]="message.incoming !== userView" [class.outgoing]="message.incoming === userView" [matTooltip]="message.createdAt | date:'shortTime'" matTooltipPositionAtOrigin matTooltipShowDelay="500">
  <div class="message" [class.incoming]="message.incoming !== userView" [class.outgoing]="message.incoming === userView" [class.video]="message.videoId">
    @if (mediaUrls.length > 0) {
      <div class="message-media-container">
        @for (mediaUrl of mediaUrls; track mediaUrl) {
          <img [src]="mediaUrl" class="message-media" alt="Message media" i18n-alt />
        }
      </div>
    }
    @if (message.audioUrl) {
      <div class="message-audio">
        <audio controls [src]="message.audioUrl"></audio>
      </div>
    }
    <div class="message-body" [class.emoji]="isEmojiOnly" style="white-space: pre-wrap" [innerHTML]="message.body"></div>
    @if (message.videoId) {
      <div class="message-media-container">
        <shared-video-player [videoId]="message.videoId"></shared-video-player>
      </div>
    }
    @if (message.sendBy) {
      <div class="message-meta">
        <span class="message-sender">{{ message.sendBy.displayName }}</span>
      </div>
    }
  </div>
</div>
